import React from "react"
import { connect } from "react-redux"
import { Container, Row, Col, Modal } from "reactstrap"
import Flickity from "react-flickity-component"
import Img from "gatsby-image"

import { setShowInfoPopup, setInfoPopupData } from "../../state/global"

import branding_icon from "../../images/icon/icon-branding-green.svg"
import design_icon from "../../images/icon/icon-design-green.svg"
import collaboration_icon from "../../images/icon/icon-collaboration-green.svg"
import storytelling_icon from "../../images/icon/icon-storytelling-green.svg"
import retail_icon from "../../images/icon/icon-retail-green.svg"
import editorial_icon from "../../images/icon/icon-editorial-green.svg"
import mpl_icon from "../../images/icon/icon-mpl.svg"

import poster from "../../images/poster.png"

import tick from "../../images/icon/crop-marks.svg"

class CaseStudyFeatured extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: null,
      informationModal: null,
      initialInformation: true,
      informationIndex: 0,
      selectedIndex: 1,
      carousel: null,
      hover: null,
    }
    this._onTouchMobile = this._onTouchMobile.bind(this)
    this._moveCarousel = this._moveCarousel.bind(this)
  }
  _onTouchMobile() {
    this.flkty.on("settle", () => {
      this.props.dispatch(setShowInfoPopup(false))
      this.setState({
        selectedIndex: this.flkty.selectedIndex + 1,
      })
      if (this.flkty.selectedIndex === 0) {
        this.setState({ initialInformation: true })
      } else {
        this.setState({
          informationIndex: this.flkty.selectedIndex - 1,
          initialInformation: false,
        })
      }
    })
  }

  _moveCarousel(obj, dir) {
    this.props.dispatch(setShowInfoPopup(false))
    if (dir === "next") {
      this.flkty.next()
      this.setState({
        selectedIndex: obj.selectedIndex + 1,
      })
    } else if (dir === "previous") {
      this.flkty.previous()
      this.setState({
        selectedIndex: obj.selectedIndex + 1,
      })
    }
    if (obj.selectedIndex === 0) {
      this.setState({ initialInformation: true })
    } else {
      this.setState({
        informationIndex: obj.selectedIndex - 1,
        initialInformation: false,
      })
    }
  }

  render() {
    let { mobile } = this.props
    let caseStudies = this.props.featured
    console.log(this.state.modal, this.state.hover, "modal case study featured --- ")
    let options = {
      draggable: mobile ? true : false,
      initialIndex: 0,
      wrapAround: true,
      pageDots: false,
      adaptiveHeight: true,
      selectedAttraction: 0.2,
      friction: 0.8,
      fade: true,
      prevNextButtons: false,
    }
    let display = caseStudies.map((i, idx) => {
      let imageArray = i.caseStudyImages
      let caseStudyLength = imageArray.length + 1
      let images
      if (imageArray) {
        images = imageArray.map((e, idx) => {
          if (e.file.contentType.split("/")[0] === "video") {
            return (
              <div key={idx} className="carousel-video-container">
                <video controls autoPlay={!mobile} muted loop poster={poster}>
                  <source src={e.file.url} type="video/mp4" />
                </video>
              </div>
            )
          } else {
            return (
              <div key={idx} className="carousel-img-container">
                <div
                  className="no-flick"
                  style={{
                    background: `url(${e.file.url})`,
                    height: `102.4vh`,
                    backgroundPosition: `${mobile ? "center" : "center"}`,
                    backgroundSize: `contain`,
                    backgroundRepeat: `no-repeat`,
                  }}
                ></div>
              </div>
            )
          }
        })
      }

      return (
        <button
          key={idx}
          id={i.clientName.split(" ")[0]}
          className="case-study-container"
          role="button"
          tabIndex={0}
          onClick={() => this.setState({ modal: i.clientName, hover: i.clientName })}
          onKeyDown={() => this.setState({ modal: i.clientName })}
          // onMouseOver={() => this.setState({ hover: i.clientName })}
          // onFocus={() => this.setState({ hover: null })}
          // onMouseOut={() => this.setState({ hover: null })}
          // onBlur={() => this.setState({ hover: null })}
        >
          <div className="logo-box" onMouseOver={() => this.setState({ hover: i.clientName })} onMouseOut={() => this.setState({ hover: null })}>
            <Img
              fluid={
                this.state.hover === i.clientName
                  ? i.logoHover.fluid
                  : i.logo.fluid
              }
              className="logo"
            />
          </div>

          <Modal
            toggle={() => this.setState({ modal: null })}
            isOpen={this.state.modal === i.clientName}
            className="case-study-modal"
          >
            <div
              className="modal-fixed-item close-modal"
              role="button"
              tabIndex={0}
              onKeyDown={() => {
                if (this.state.hover) {
                  this.setState({ hover: null })
                }
                this.setState({ modal: null, selectedIndex: 1 })
                this.props.dispatch(setShowInfoPopup(false))
              }}
              onClick={() => {
                console.log("close click")
                if (this.state.hover) {
                  this.setState({ hover: null })
                }
                this.setState({ modal: null, selectedIndex: 1 })
                this.props.dispatch(setShowInfoPopup(false))
              }}
            >
              [close]
            </div>
            <div className="modal-fixed-item case-study-id">
              CASE STUDY #00{idx + 1}
            </div>

            <div
              className={
                "modal-fixed-item capabilities " +
                (this.state.selectedIndex === 1 || mobile ? "show" : "")
              }
            >
              {i.branding && (
                <div className="capability">
                  <img src={branding_icon} alt="" />
                  <span className="tooltip">Branding</span>
                </div>
              )}
              {i.designDevelopment && (
                <div className="capability">
                  <img src={design_icon} alt="" />
                  <span className="tooltip">Design & Development</span>
                </div>
              )}
              {i.collaborationCuration && (
                <div className="capability">
                  <img src={collaboration_icon} alt="" />
                  <span className="tooltip">Collaboration Curation</span>
                </div>
              )}
              {i.storytelling && (
                <div className="capability">
                  <img src={storytelling_icon} alt="" />
                  <span className="tooltip">Storytelling</span>
                </div>
              )}
              {i.retailStrategy && (
                <div className="capability">
                  <img src={retail_icon} alt="" />
                  <span className="tooltip">Retail Strategy</span>
                </div>
              )}
              {i.editorial && (
                <div className="capability">
                  <img src={editorial_icon} alt="" />
                  <span className="tooltip">Editorial</span>
                </div>
              )}
              {i.mpl && (
                <div className="capability">
                  <img src={mpl_icon} alt="" />
                  <span className="tooltip">MPL</span>
                </div>
              )}
            </div>

            <div className="modal-fixed-item case-study-slides">
              {this.state.selectedIndex} / {caseStudyLength}
            </div>
            {!this.state.initialInformation && (
              <div className="modal-fixed-item case-study-info">
                <div
                  role="button"
                  tabIndex={0}
                  onKeyDown={() => {
                    this.props.dispatch(setShowInfoPopup(true))
                    this.props.dispatch(
                      setInfoPopupData({
                        type: "caseStudy",
                        title: i.clientName,
                        info: `${
                          this.state.initialInformation ||
                          !i.caseStudyImages[this.state.informationIndex]
                            .description
                            ? i.description.description
                            : i.caseStudyImages[this.state.informationIndex]
                                .description
                        }`,
                        link: null,
                      })
                    )
                  }}
                  onClick={() => {
                    this.props.dispatch(setShowInfoPopup(true))
                    this.props.dispatch(
                      setInfoPopupData({
                        type: "caseStudy",
                        title: i.clientName,
                        info: `${
                          this.state.initialInformation ||
                          !i.caseStudyImages[this.state.informationIndex]
                            .description
                            ? i.description.description
                            : i.caseStudyImages[this.state.informationIndex]
                                .description
                        }`,
                        link: null,
                      })
                    )
                  }}
                >
                  {mobile ? "info" : "information"}
                </div>
              </div>
            )}

            <div className="case-study-modal-container">
              <div className="click-container">
                <div
                  className="previous"
                  role="button"
                  tabIndex={0}
                  onKeyDown={() => {
                    this._moveCarousel(this.flkty, "previous")
                  }}
                  onClick={() => {
                    this._moveCarousel(this.flkty, "previous")
                  }}
                >
                  <img
                    src={tick}
                    alt=""
                    id="tick-one"
                    className="tick-mark no-flick"
                  />

                  <img
                    src={tick}
                    alt=""
                    id="tick-three"
                    className="tick-mark"
                  />
                </div>
                <div
                  className="next"
                  role="button"
                  tabIndex={0}
                  onKeyDown={() => this._moveCarousel(this.flkty, "next")}
                  onClick={() => this._moveCarousel(this.flkty, "next")}
                >
                  <img src={tick} alt="" id="tick-two" className="tick-mark" />
                  <img src={tick} alt="" id="tick-four" className="tick-mark" />
                </div>
              </div>
              <Flickity
                className={"carousel"}
                options={options}
                flickityRef={c => (this.flkty = c)}
              >
                <div
                  className="carousel-detail-container"
                  onTouchStart={() => this._onTouchMobile()}
                >
                  <h2 className="w-100">{i.description.description}</h2>
                </div>

                {images}
              </Flickity>
            </div>
          </Modal>
        </button>
      )
    })

    return (
      <Container fluid id="caseStudyFeatured">
        <Row className="my-4 align-items-center flex-wrap case-studies">{display}</Row>
      </Container>
    )
  }
}

export default connect(
  state => ({
    mobile: state.global.mobile,
  }),
  null
)(CaseStudyFeatured)
